import { AdminQuotationPath } from "@/common/enum/path";
import { formatDateToYYYYMMDD } from "@/common/util/date-util";
import { formatCartItemsDisplay } from "@/common/util/format-cart-items-display";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Underline } from "@/components/typography/Body14Underline";
import { QuoteDetailDto } from "@/types/dto/quote-detail-dto";
import { Table } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { formatCommasNumber } from "../../../common/util/format-number-with-commas";
import { CustomCell } from "../CustomCell";

interface Props {
  data: QuoteDetailDto;
  index: number;
  startIndex: number;
}

export const AdminQuoteRow: React.FC<Props> = ({ data, index, startIndex }) => {
  const navigate = useNavigate();
  const item = data;

  const handleClick = () => {
    navigate(
      `${AdminQuotationPath.QUOTATION_DETAIL.replace(":id", String(item.id))}`
    );
  };

  return (
    <Table.Row key={item.id} className="bg-primary-white">
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {startIndex - index}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatDateToYYYYMMDD(new Date(item.createdAt))}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="cursor-pointer" onClick={handleClick}>
        <CustomCell>
          <Body14Underline className="text-semantic-text-body">
            {item.quotationNumber}
          </Body14Underline>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.ordererName}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatCommasNumber(item.finalPriceSum)}원
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatCartItemsDisplay(item.cartItems)}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.ordererName}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.constructionName}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.constructionWorkName}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
